import { mapGetters } from 'vuex';

import { DEFAULT_MODAL_HEIGHT, resizeModalDialogIniFrame } from '@/utils/modal-utils.js';

import { getCollapseSimplifyViewObserver } from '@/utils/collapse-simplify-view-observer';
import { planTypes } from "@/common/constants";

export default {
  computed: {
    ...mapGetters(['boughtPlans', 'getSelectedPlans', 'isCollapseSimplifyView', 'currentEditPlan']),
    mxIsSimplifyForProEdit() {
      const { simplify, edit, modal } = this.$context.is;
      const isProPlusOrBizPlus = this.getSelectedPlans.some((item) => [planTypes.ZONE_PRO_PLUS, planTypes.ZOOM_ONE_BUNDLE].includes(item.type));
      return modal & simplify && edit && !isProPlusOrBizPlus;
    },
    mxClassForSimplify() {
      return this.mxIsSimplifyForProEdit ? ['opc-simplify'] : [];
    },
    mxClassForSimplifyCompound() {
      return this.mxIsSimplifyCompoundView ? ['opc-simplify'] : [];
    },
    mxShowExtraElementForCollapseSimplifyView() {
      return !this.mxIsSimplifyForProEdit || this.mxIsSimplifyCompoundView;
    },
    mxShowOperationButtonForSimplifyView() {
      return this.mxIsSimplifyForProEdit && this.isCollapseSimplifyView;
    },
    mxIsSimplifyCompoundView() {
      return this.mxIsSimplifyForProEdit && !this.isCollapseSimplifyView;
    },
  },
  methods: {
    mxCheckCollapseSimplifyView({ type, billingCycle, selectedNumber, capacity }, forceExpand) {
      if (!this.mxIsSimplifyForProEdit || !this.isCollapseSimplifyView) return;
      const boughtBillingCycle = this.currentEditPlan?.billing_cycle;
      const boughtLicenses = this.currentEditPlan?.cartInfo?.selected_number;
      const boughtCapacity = this.currentEditPlan?.capacity;
      const boughtCategory = this.currentEditPlan?.category;
      const planChange = this.getSelectedPlans.filter((p) => p.type === type).some((p) => p.category !== boughtCategory);
      if (forceExpand || billingCycle !== boughtBillingCycle || selectedNumber !== boughtLicenses || capacity !== boughtCapacity || planChange) {
        if (this.isCollapseSimplifyView) {
          this.$store.commit("updateIsCollapseSimplifyView", false);
          const collapseSimplifyViewObserver = getCollapseSimplifyViewObserver();
          collapseSimplifyViewObserver?.disconnect?.();
          // * resize window
          resizeModalDialogIniFrame({
            height: DEFAULT_MODAL_HEIGHT,
            capToViewport: true,
          });
        }
      }
    },
    mxAnchorIntersectionObserver(ancherEle, callback = () => {}) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              callback(observer, entry.target);
            }
          });
        },
        {
          threshold: 1,
        },
      );
      if (ancherEle) {
        observer.observe(ancherEle);
      }
    },
  },
};
